import React, { useState } from 'react';
import { Container, Typography, Box, Tabs, Tab } from '@mui/material';
import { ContractorTypeManagement } from '../components/ContractorTypeManagement';
import { UnifiedContractorManagement } from '../components/UnifiedContractorManagement';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`contractor-tabpanel-${index}`}
      aria-labelledby={`contractor-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ pt: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

const Contractors: React.FC = () => {
  const [currentTab, setCurrentTab] = useState(0);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setCurrentTab(newValue);
  };

  return (
    <Container maxWidth="xl">
      <Box sx={{ py: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom fontWeight="bold">
          Contractors
        </Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          Manage your contractor types and contractors
        </Typography>

        <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
          <Tabs value={currentTab} onChange={handleTabChange}>
            <Tab label="👷 All Contractors" />
            <Tab label="⚙️ Contractor Types" />
          </Tabs>
        </Box>

        <TabPanel value={currentTab} index={0}>
          <UnifiedContractorManagement />
        </TabPanel>

        <TabPanel value={currentTab} index={1}>
          <ContractorTypeManagement />
        </TabPanel>
      </Box>
    </Container>
  );
};

export default Contractors;

